export default __webpack_public_path__ + "static/media/IMG_5357.8695c09b.JPG";